import React from "react";
import {
  Paper,
  IconButton,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  Avatar,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import PersonIcon from "@mui/icons-material/Person";

export const PerformerView = ({
  performer,
  handleDelete,
  onHeadlinerChange,
  dhProps,
}) => {
  const displayName = (performer.name || "").trim() || "Unnamed";
  const isHeadliner = performer.isHeadliner ?? false;

  return (
    <Paper
      width="100%"
      sx={{
        paddingLeft: "20px",
        paddingRight: "20px",
        paddingTop: "20px",
        paddingBottom: "20px",
      }}
      elevation={4}
    >
      <Box sx={{ textDecoration: "none" }}>
        <Box
          width="100%"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          gap="20px"
        >
          <Box
            {...dhProps}
            paddingTop="5px"
            paddingBottom="0px"
            paddingLeft="5px"
            paddingRight="5px"
          >
            <UnfoldMoreIcon color="primary" />
          </Box>
          {performer.headshotUrl ? (
            <Box
              component="img"
              src={performer.headshotUrl}
              alt=""
              sx={{
                width: 40,
                height: 40,
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          ) : (
            <Avatar sx={{ width: 40, height: 40 }}>
              <PersonIcon />
            </Avatar>
          )}
          <Box flexGrow={1}>
            <Typography variant="body1" color="text.primary">
              {displayName}
            </Typography>
            {performer.email && (
              <Typography variant="body2" color="text.secondary">
                {performer.email}
              </Typography>
            )}
          </Box>
          <FormControlLabel
            control={
              <Checkbox
                checked={isHeadliner}
                onChange={(e) => onHeadlinerChange?.(e.target.checked)}
                name="headliner"
                size="small"
              />
            }
            label="Headliner"
          />
          <IconButton
            sx={{ marginLeft: "auto" }}
            onClick={(e) => {
              e.preventDefault();
              handleDelete();
            }}
            aria-label="Remove performer"
          >
            <DeleteIcon />
          </IconButton>
        </Box>
      </Box>
    </Paper>
  );
};
